// Fixed proposed dispatch dates; never reset the countdown on reload.
// Set inventory from verified order data. null means unavailable, not zero sales.
window.RELIV_LAUNCH = {
 deadline:'2026-11-03T09:00:00+02:00', countdownLabel:'NEXT BATCH STARTS IN',
 shippingDate:'2026-11-03', preview:false,
 batches:[
  {name:'Batch 01',shipsAt:'2026-11-03T09:00:00+02:00',status:'open',capacity:null,sold:null},
  {name:'Batch 02',shipsAt:'2026-11-23T09:00:00+02:00',status:'locked'},
  {name:'Batch 03',shipsAt:'2026-12-13T09:00:00+02:00',status:'locked'}
 ]
};
